import { api } from "@/app/app.api";
import { RequestMethod } from "@/shared/utils/RequestMethod";
import { camelToSnake, snakeToCamel } from "caseparser";
import { objectToFormData } from "@/shared/utils/data";

export interface PostMetaParams {
    branchId?: number;
}

export interface PostMetaResponse {
    states: string[];
    typeReactions: string[];
    managers: any[];
    assisteds: any[];
    assistedSpecialists: any[];
    lessons: any[];
    lessonSpecialists: any[];
    sets: any[];
    bonds: any[];
    slotsBonds: any[];
    fees: any[];
    nutritionPlan: any[];
    trainingPlan: any[];
    categories: any[]
}

export interface CreatePostPayload {
    branchId: number;
    htmlDesign: string;
    title: string;
    managerId: number;
    senderId: number;
    send: 0 | 1;
    state: string | null;
    [key: string]: any;
}

export const postInternalChatsApi = api
    .enhanceEndpoints({
        addTagTypes: ["postMeta", "postsMasters"],
    })
    .injectEndpoints({
        overrideExisting: false,
        endpoints: (builder) => ({
            getPostMeta: builder.query<PostMetaResponse, PostMetaParams>({
                query: ({ branchId }) => ({
                    url: `/posts-masters/meta/${branchId ?? ""}`,
                    method: RequestMethod.GET,
                }),
                transformResponse: (response: any) => snakeToCamel(response),
                providesTags: ["postMeta"],
            }),
            createPost: builder.mutation<any, CreatePostPayload>({
                query: (payload) => ({
                    url: `/posts-masters`,
                    method: RequestMethod.POST,
                    body: objectToFormData(camelToSnake(payload)),
                    formData: true,
                }),
                transformResponse: (response: any) => snakeToCamel(response.data),
                invalidatesTags: ["postsMasters"],
            }),
            getPost: builder.query<any, { id: number }>({
                query: ({ id }) => ({
                    url: `/posts-masters/${id}`,
                    method: RequestMethod.GET,
                }),
                transformResponse: (response: any) => snakeToCamel(response.data),
                providesTags: ["postsMasters"],
            }),
        }),
    });

export const {
    useGetPostMetaQuery,
    useCreatePostMutation,
    useGetPostQuery,
} = postInternalChatsApi;
